<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <service-settings-popup
        v-if="popupData"
        :popup-data="popupData"
        :non-linear-options="nonLinearOptions"
        @save-settings="saveSettings"
        @close-popup="closePopup"
    ></service-settings-popup>
    <business-models-modal ref="businessmodelsmodalref" />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="!entity.enabled && $_updateActionAllowed"
             class="btn btn_action btn_grey btn_enable"
             :title="'Aktivovat' | translate"
             @click.prevent.stop="updateEntityActive('enabled', true)"
             v-translate>Aktivovat</a>
          <a v-if="entity.enabled  && $_updateActionAllowed"
             class="btn btn_action btn_grey btn_disable"
             :title="'Deaktivovat' | translate"
             @click.prevent.stop="updateEntityActive('enabled', false)"
             v-translate>Deaktivovat</a>
          <a v-if="$_deleteActionAllowed"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity"
             v-translate>Smazat</a>
        </p>
        <h1>{{entity.name}}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_readActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                    :disabled="true"
                >
                </operator-select>
              </div>
              <div class="field_right">
                <select-box
                    id="packagebusinessmodel"
                    :options="businessModelOptions"
                    v-model="businessModelIdComputed"
                    :disabled="true"
                    ref="packagebusinessmodelref"
                >
                  <translate class="translate">Business model</translate>
                </select-box>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <detail-entity-info
              :entity="entity"></detail-entity-info>
            </div>
            <div class="right">
              <div class="field_left">
                <text-input id="name"
                            :required="true"
                            v-model="entity.name"
                            :disabled="disabled"
                            ref="servicenameref"
                >
                  <translate class="translate">Název služby</translate>
                </text-input>
                <select-box id="timeshiftenabled"
                            v-model="timeshift"
                            :disabled="disabled"
                            :options="nonLinearOptions"
                            ref="timeshiftenabledref"
                >
                  <translate class="translate">Timeshift</translate>
                </select-box>
                <select-box id="catchupenabled"
                            :disabled="disabled"
                            v-model="catchup"
                            :options="nonLinearOptions"
                            ref="catchupenabledref"
                >
                  <translate class="translate">Catchup</translate>
                </select-box>
                <text-input id="catchuphours"
                            :disabled="disabled || !catchup"
                            v-model="catchupHours"
                            ref="catchuphoursref"
                >
                  <translate class="translate">Počet hodin catchupu</translate>
                </text-input>
                <text-input id="devicecount"
                            v-model="entity.device_count"
                            ref="devicecountsref"
                            :disabled="disabled"
                >
                  <translate class="translate">Počet současně streamujících zařízení</translate>
                </text-input>
                <text-input id="subscriberprofilecount"
                            v-model="entity.subscriber_profile_count"
                            ref="subscriberprofilecountsref"
                            :disabled="disabled"
                >
                  <translate class="translate">Počet uživatelských profilů</translate>
                </text-input>
              </div>
              <div class="field_right">
                <select-box id="weight"
                            :required="true"
                            :disabled="disabled"
                            v-model="entity.id_weight_category"
                            :options="weightCategoriesOptions"
                            ref="serviceweightref"
                >
                  <translate class="translate">Váha služby</translate>
                </select-box>
                <select-box id="pvrenabled"
                            :disabled="disabled"
                            v-model="pvr"
                            :options="nonLinearOptions"
                            ref="pvrenabledref"
                >
                  <translate class="translate">PVR</translate>
                </select-box>
                <text-input id="pvrlifetime"
                            :disabled="disabled || !pvr"
                            v-model="entity.pvr_lifetime_in_days"
                            ref="pvrlifetimeref"
                >
                  <translate class="translate">Počet dní pro uchování nahrávek</translate>
                </text-input>
                <text-input id="pvrfreeminutes"
                            :disabled="disabled || !pvr"
                            v-model="entity.pvr_free_minutes"
                            ref="pvrfreeminutesref"
                >
                  <translate class="translate">Počet volných minut</translate>
                </text-input>
                <checkbox-input
                    id="deviceaddon"
                    v-model="entity.device_addon"
                    ref="deviceaddonref"
                    class="checkbox"
                    :disabled="disabled"
                >
                  <translate class="translate">Přičítat počet současně streamujících zařízení k výsledné službě</translate>
                </checkbox-input>
                <checkbox-input
                    id="subscriberprofileaddon"
                    v-model="entity.subscriber_profile_addon"
                    ref="subscriberprofileaddonref"
                    class="checkbox"
                    :disabled="disabled"
                >
                  <translate class="translate">Přičítat počet uživatelských profilů k výsledné službě</translate>
                </checkbox-input>
              </div>
              <div class="field_left">
                <date-picker id="valid_from"
                             attrKey="valid_from"
                             date-format="d. m. yy"
                             v-model="entity.valid_from"
                             :disabled="disabled"
                             @update-date="updateEntityDate"
                >
                  <translate class="translate">Aktivní od</translate>
                </date-picker>
              </div>
              <div class="field_right">
                <date-picker id="valid_to"
                             attrKey="valid_to"
                             date-format="d. m. yy"
                             v-model="entity.valid_to"
                             :disabled="disabled"
                             @update-date="updateEntityDate"
                >
                  <translate class="translate">Aktivní do</translate>
                </date-picker>
              </div>
              <div class="field_left">
                <date-picker id="assignable_to"
                             attrKey="assignable_to"
                             date-format="d. m. yy"
                             v-model="entity.assignable_to"
                             :disabled="disabled"
                             @update-date="updateEntityDate"
                >
                  <translate class="translate">Přiřaditelné do</translate>
                </date-picker>
              </div>
              <div class="field_right">
                <textarea-input
                    id="note"
                    rows=6
                    cols=50
                    v-model="entity.note"
                    :disabled="disabled"
                >
                  <translate class="translate">Poznámka</translate>
                </textarea-input>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Nastavení reklam</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <select-box id="skippable"
                            v-model="skippable"
                            :disabled="this.entity.autoskip || !$_updateActionAllowed"
                            :options="nonLinearOptions"
                            ref="skippableref"
                ><translate class="translate">Povolit přeskakování reklam - živě a timeshift</translate>
                </select-box>
                <text-input id="skipafterseconds"
                            v-model="skipAfterSeconds"
                            ref="skipaftersecondsref"
                            :disabled="!allowSkipAfter || !$_updateActionAllowed"
                >
                  <translate class="translate">Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením - živě a timeshift</translate>
                </text-input>
                <text-input id="timewithnoadvertisementafterstartseconds"
                            v-model="timeWithNoAdvertisementAfterStartSeconds"
                            ref="timewithnoadvertisementafterstartsecondsref"
                            :disabled="this.entity.autoskip || !$_updateActionAllowed"
                >
                  <translate class="translate">Počet vteřin od začátku přehrávání, po kterém již nelze v reklamě přetáčet - živě a timeshift</translate>
                </text-input>
                <select-box id="allowskipmultipleadvertisementblocks"
                            v-model="allowSkipMultipleAdvertisementBlocks"
                            :disabled="this.entity.autoskip || !$_updateActionAllowed"
                            :options="nonLinearOptions"
                            ref="allowskipmultipleadvertisementblocksref"
                ><translate class="translate">Povolit přeskakování více reklamních bloků - živě a timeshift</translate>
                </select-box>
                <select-box id="autoskip"
                            v-model="autoskip"
                            :disabled="!$_updateActionAllowed"
                            :options="nonLinearOptions"
                            ref="autoskipref"
                ><translate class="translate">Automaticky přeskakovat reklamy</translate>
                </select-box>
              </div>
              <div class="field_right">
                <select-box id="skippablenonlinear"
                            v-model="skippableNonlinear"
                            :disabled="this.entity.autoskip || !$_updateActionAllowed"
                            :options="nonLinearOptions"
                            ref="skippablenonlinearref"
                ><translate class="translate">Povolit přeskakování reklam - catchup a pvr</translate>
                </select-box>
                <text-input id="skipaftersecondsnonlinear"
                            v-model="skipAfterSecondsNonlinear"
                            ref="skipaftersecondsnonlinearref"
                            :disabled="!allowSkipAfterNonlinear || !$_updateActionAllowed"
                >
                  <translate class="translate">Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením - catchup a pvr</translate>
                </text-input>
                <text-input id="timewithnoadvertisementafterstartsecondsnonlinear"
                            v-model="timeWithNoAdvertisementAfterStartSecondsNonlinear"
                            ref="timewithnoadvertisementafterstartsecondsnonlinearref"
                            :disabled="this.entity.autoskip || !$_updateActionAllowed"
                >
                  <translate class="translate">Počet vteřin od začátku přehrávání, po kterém již nelze v reklamě přetáčet - catchup a pvr</translate>
                </text-input>
                <select-box id="allowskipmultipleadvertisementblocksnonlinear"
                            v-model="allowSkipMultipleAdvertisementBlocksNonlinear"
                            :disabled="this.entity.autoskip || !$_updateActionAllowed"
                            :options="nonLinearOptions"
                            ref="allowskipmultipleadvertisementblocksnonlinearref"
                ><translate class="translate">Povolit přeskakování více reklamních bloků - catchup a pvr</translate>
                </select-box>
              </div>
            </div>
          </section>
          <section>
            <div class="left"><h2 v-translate>Pravidelné nahrávky</h2></div>
            <div class="right">
              <div class="field_left">
                <select-box id="periodicpvrenabled"
                            :disabled="disabled"
                            v-model="periodic_pvr"
                            :options="nonLinearOptions"
                            ref="periodicpvrenabledref"
                >
                  <translate class="translate">Pravidelné nahrávky</translate>
                </select-box>
                </div>
              <div class="field_right">
                <text-input id="periodicpvrcount"
                            v-model="entity.periodic_pvr_count"
                            :disabled="disabled || !periodic_pvr"
                            ref="periodicpvrcountref"
                >
                  <translate class="translate">Maximální počet nahrávek</translate>
                </text-input>
              </div>
              <div class="field_left">
                <checkbox-input
                    id="periodicpvraddon"
                    v-model="entity.periodic_pvr_addon"
                    ref="periodicpvraddonref"
                    :disabled="disabled || !periodic_pvr"
                    class="checkbox"
                >
                  <translate class="translate">Přičítat počet nahrávek k výsledné službě</translate>
                </checkbox-input>
              </div>
              <div class="field_right">
                <text-input id="periodicpvrdaysback"
                            v-model="entity.periodic_pvr_days_back"
                            :disabled="disabled || !periodic_pvr"
                            ref="periodicpvrdaysbackref"
                >
                  <translate class="translate">Počet dní za CatchUp, kdy lze pouštět nahrávky</translate>
                </text-input>
              </div>
            </div>
          </section>
          <channel-checkbox-list-section
              ref="packageListRef"
              v-if="!loading"
              :editable="$_updateActionAllowed"
              :single-list="true"
              :title="'Balíčky' | translate"
              :group-id=packageGroupPrefix
              :items="allPackages"
              :selected-items="entity.id_channel_packages"
              @toggle-select="entity.id_channel_packages = arguments[0]"
              :showSettings="true"
              :showNonlinear="true"
              nonlinearDataKey="id_channel_packages"
              :nonlinearSettings="nonLinearContentSettings"
              @onSettingsClick="initSettingsPopupPackage"
          >
          </channel-checkbox-list-section>
          <template>
            <channel-checkbox-list-section
                ref="channelsListRef"
                v-if="!loading"
                :editable="$_updateActionAllowed && showChannelsSection"
                :title="'Kanály' | translate"
                :show-channel-sort="true"
                :group-id=channelGroupPrefix
                :items="allChannels"
                :selected-items="entity.id_channels"
                @toggle-select="entity.id_channels = arguments[0]"
                :showSettings="true"
                :showNonlinear="true"
                :nonlinearSettings="nonLinearContentSettings"
                nonlinearDataKey="id_channels"
                @onSettingsClick="initSettingsPopupChannel"
                @show-business-models="$refs.businessmodelsmodalref.showBusinessModels(arguments[0])"
            ></channel-checkbox-list-section>
          </template>
          <section>
            <div class="left"><h2 v-translate>Balíček videotéky</h2></div>
            <div class="right checkbox_group">
              <div class="field_left">
              <select-box id="vod"
                          :disabled="disabled"
                          v-model="vod"
                          :options="nonLinearOptions"
                          ref="vodref"
              >
                <translate class="translate">Videotéka</translate>
              </select-box>
              </div>
              <ul>
                <li v-for="provider in providers" :key="provider.id">
                  <p><strong>{{ provider.name }}</strong></p>
                  <radio-input
                      v-for="vod_package in provider.packages"
                      :key="vod_package.id"
                      :id="vod_package.id"
                      :name="vod_package.id+'_radio'"
                      p-class="field"
                      v-model="entity.id_vod_package"
                      :val="entity.id_vod_package"
                      :disabled="disabled || !vod"
                  >
                    {{vod_package.name}}
                  </radio-input>
                </li>
              </ul>
            </div>
          </section>
        </div>
        <detail-bottom-buttons
            v-if="$_updateActionAllowed"
            section-class="buttons"
            :show-link="true"
            :module-name="moduleName"
            @submit-form="submitForm"
        ></detail-bottom-buttons>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import services from "@/components/views/services/mixins/services"
import ServiceSettingsPopup from "@/components/common/ServiceSettingsPopup"
import ChannelCheckboxListSection from "@/components/common/ChannelCheckboxListSection"
import BusinessModelsModal from "../../common/BusinessModelsModal.vue";

export default {
  name: "ServiceDetail",
  components: { BusinessModelsModal, ServiceSettingsPopup, ChannelCheckboxListSection},
  mixins: [detailActions, services],
  data() {
    return {
      popupData: null,
      providers: [],
      allChannels: [],
      allPackages: [],
      includeNonLinearContentSettings: true,
      canAddChannelsToService: null,
      channelGroupPrefix: 'channels_',
      packageGroupPrefix: 'packages_',
    }
  },
  created(ServiceService, OperatorService, BusinessModelService, VodProviderService) {
    this.entityService = ServiceService
    this.operatorService = OperatorService
    this.businessModelService = BusinessModelService
    this.vodProviderService = VodProviderService
    this.createdInit()
        .then(() => {
          if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.getOperatorsAndBusinessModels(true, true)
          }

          if (!this.entity.global) {
            this.operatorService.getEntity(this.entity.id_operator)
                .then(data => {
                  this.canAddChannelsToService = data['operator']['can_add_channels_to_service']
                })
          }

          this.vodProviderService.getPackagesForService({
            'id_business_model': this.entity.id_business_model,
            'id_operator': this.entity.id_operator
          })
              .then((data) => {
                this.providers = data['vod_providers'];
              });
        })
  },
  computed: {
    disabled(){
      return !this.$_updateActionAllowed;
    },
    showChannelsSection() {
      return (!!(this.entity.global && this.$_updateActionAllowedAllOrOwnAndGlobal)
          || (!this.entity.global && this.canAddChannelsToService));
    },
  },
  methods: {
    getEntity() {
      this.setLoadingMessage()
      return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then(data => {
            this.resetFields()
            this.emptyMessage()
            this.entity = data[this.entityName]

            this.allChannels = data['all_channels']
            this.allPackages = data['all_packages']
            this.serviceWeightCategories = data['weight_categories']
            this.nonLinearContentSettings = this.getNonlinearContentSettings(data);
            this.initialNonLinearContentSettingsCount = this.nonLinearContentSettings.length
            this._afterGetEntityActions(data)
          })
          .catch(function () {
            this.$router.push({name: this.moduleName})
          }.bind(this, console))
    },
    getNonlinearContentSettings(data){
      let settings = [...data[this.entityName]['non_linear_content_settings']];
      settings.forEach((item) => {
        let id_channel_packages = [];
        item.id_channel_packages.forEach((id) => {
          id_channel_packages.push(this.packageGroupPrefix+id);
        })
        item.id_channel_packages = id_channel_packages;

        let id_channels = [];
        item.id_channels.forEach((id) => {
          id_channels.push(this.channelGroupPrefix+id);
        })
        item.id_channels = id_channels;
      })

      return settings;
    },
    getPackageData(packageId) {
      return this._.find(this.allPackages, function (item) {
        return item.id === packageId
      })
    },
    getChannelData(channelId) {

      return this._.find(this.allChannels, function (item) {
        return item.id === channelId
      })
    },
    initSettingsPopupPackage(id) {
      let packageData = this.getPackageData(id)
      if (packageData !== undefined) {
        let packageSettings = this.findSettingsById(id, 'id_channel_packages')
        let popupData = {
          'id': id,
          'name': packageData.name,
          'catchup': null,
          'catchup_hours': null,
          'timeshift': null,
          'pvr': null,
          'periodic_pvr': null,
          'key': 'id_channel_packages'
        }
        if (packageSettings !== null) {
          popupData['catchup'] = packageSettings['catchup']
          popupData['catchup_hours'] = packageSettings['catchup_hours']
          popupData['timeshift'] = packageSettings['timeshift']
          popupData['pvr'] = packageSettings['pvr']
          popupData['periodic_pvr'] = packageSettings['periodic_pvr']
        }
        this.popupData = popupData
      }
    },
    initSettingsPopupChannel(id) {
      let channelData = this.getChannelData(id)
      let channelSettings = this.findSettingsById(id, 'id_channels')
      let popupData = {
        'id': id,
        'name': channelData.name,
        'catchup': null,
        'catchup_hours': null,
        'timeshift': null,
        'pvr': null,
        'periodic_pvr': null,
        'key': 'id_channels'
      }
      if (channelSettings !== null) {
        popupData['catchup'] = channelSettings['catchup']
        popupData['catchup_hours'] = channelSettings['catchup_hours']
        popupData['timeshift'] = channelSettings['timeshift']
        popupData['pvr'] = channelSettings['pvr']
        popupData['periodic_pvr'] = channelSettings['periodic_pvr']
      }
      this.popupData = popupData
    },
    _beforeUpdateEntityActions(params) {
      params = this.processParamsBeforeCreateAndUpdate(params, true);

      if(Array.isArray(params.non_linear_content_settings)) {
        let newNonlinearSettings = [];
        for (let item of params.non_linear_content_settings) {
          let id_channel_packages = [];
          item.id_channel_packages.forEach((id) => {
            let cleanId = Number(id.toString().replace(this.packageGroupPrefix, ''));
            if (params.id_channel_packages.includes(cleanId)) {
              id_channel_packages.push(cleanId);
            }
          })
          item.id_channel_packages = id_channel_packages;

          let id_channels = [];
          item.id_channels.forEach((id) => {
            let cleanId = Number(id.toString().replace(this.channelGroupPrefix, ''));
            if (params.id_channels.includes(cleanId)) {
              id_channels.push(cleanId);
            }
          })
          item.id_channels = id_channels;
          if (item.id_channel_packages.length || item.id_channels.length) {
            newNonlinearSettings.push(item);
          }
        }
        params.non_linear_content_settings = newNonlinearSettings;
      }

      return params
    },
    closePopup() {
      this.popupData = null
    },
    saveSettings(data) {
      this.closePopup()
      this.setLoadingMessage();
      this.$nextTick(() => {
        let key = data.key

        let foundIndex = this.findSettingsById(data.id, key, true)
        if (foundIndex !== null) {
          let item = this.nonLinearContentSettings[foundIndex]
          if (this.settingsChanged(data, item)) {
            // remove ID from original settings
            item[key] = this._.difference([...item[key]], [data.id])

            // if resulting array is empty array, remove it
            if (item[key].length === 0) {
              this.nonLinearContentSettings.splice(foundIndex, 1)
            }

            if (this.settingsFilled(data)) {
              this.addToExistingSettingsRowOrAddNew(data, key, data.id)
            }
          }
        } else {
          if (this.settingsFilled(data)) {
            this.addToExistingSettingsRowOrAddNew(data, key, data.id)
          }
        }
        this.$nextTick(() => {
          this.emptyMessage();
        })
      });
    },
    settingsChanged(data, item) {
      return Number(item['catchup_hours']) !== Number(data['catchup_hours'])
          || item['timeshift'] !== data['timeshift']
          || item['catchup'] !== data['catchup']
          || item['pvr'] !== data['pvr']
          || item['periodic_pvr'] !== data['periodic_pvr']
    },
    settingsFilled(data) {
      return Number(data['catchup_hours']) > 0
          || (data['timeshift'] === true || data['timeshift'] === false)
          || (data['catchup'] === true || data['catchup'] === false)
          || (data['pvr'] === true || data['pvr'] === false)
          || (data['periodic_pvr'] === true || data['periodic_pvr'] === false)
    },
    addToExistingSettingsRowOrAddNew(data, key, id) {
      let sameSettingsIndex = this.findSettingsByValues(data, key, true)
      if (sameSettingsIndex !== null) {
        // add ID to found settings
        let sameSettingsItem = this.nonLinearContentSettings[sameSettingsIndex]
        sameSettingsItem[key] = this._.union([...sameSettingsItem[key]], [id])
      } else {
        this.addNewSettingsRow(data, key, id)
      }
    },
    addNewSettingsRow(data, key, id) {
      let newSettingsRow = {
        'catchup': data['catchup'],
        'catchup_hours': data['catchup_hours'],
        'timeshift': data['timeshift'],
        'pvr': data['pvr'],
        'periodic_pvr': data['periodic_pvr'],
        'id_channels': [],
        'id_channel_packages': []
      }
      newSettingsRow[key].push(id)
      this.nonLinearContentSettings.push(newSettingsRow)
    },
    findSettingsById(id, key, returnIndex = false) {
      let found = null
      this._.forEach(this.nonLinearContentSettings, function (item, index) {
        if (this._.includes(item[key], id)) {
          if (returnIndex) {
            found = index
          } else {
            found = {...item}
          }
        }
      }.bind(this))
      return found
    },
    findSettingsByValues(data, key, returnIndex = false) {
      let found = null
      this._.forEach(this.nonLinearContentSettings, function (item, index) {
        if (item['timeshift'] === data['timeshift']
            && item['pvr'] === data['pvr']
            && item['periodic_pvr'] === data['periodic_pvr']
            && item['catchup'] === data['catchup']
            && Number(item['catchup_hours']) === data['catchupHours']
            && item[key].length > 0
        ) {
          if (returnIndex) {
            found = index
          } else {
            found = {...item}
          }
        }
      }.bind(this))
      return found
    },
    hasNoChannelsAndNoPackages(item) {
      return item['id_channels'].length === 0 && item['id_channel_packages'].length === 0
    },
    showBusinessModels(businessModels) {
      if(businessModels && businessModels.length > 0) {
        this.businessModelsModalData = businessModels;
        this.$refs.businessmodelsmodalref.showModal(true)
      }
    }
  },
  watch: {
    vod(){
      if(!this.vod){
        this.entity.id_vod_package = null;
      }
    },
    skippable(){
      if(this.skippable !== true){
        this.skipAfterSeconds = "";
      }
    },
    skippableNonlinear(){
      if(this.skippableNonlinear !== true){
        this.skipAfterSecondsNonlinear = "";
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/services/ServiceDetail.vue